import {createReducer} from '@reduxjs/toolkit';

import {PRODUCT_TYPES, DOCTOR_DETAILS_DEFAULT, PRESCRIPTION_METHOD} from 'constants/product';
import {SuccessPageType} from 'desktop/pages/success/types/orderItemsTypes';

import {FieldType} from 'types/successPage';

import {
    changeField,
    setIsAutocompleteModeEnabled,
    setErrorsSuccessPage,
    fetchOrderedItems,
    changeSuccessScreen,
    clearExamBind,
    fetchExamID,
    setVisibilyFailureMessage,
    setVisiblyFields,
} from '../../actions/orderItems/orderItems';

import {initialState} from './constants';

/**
 * Ordered items reducer on success page
 */
export const orderItems = createReducer(initialState, builder => {
    builder
        .addCase(changeField, (state, action) => ({
            ...state,
            items: state.items.map(item => ({
                ...item,
                ...(item.orderItemId === action.payload.orderItemId ? action.payload : {}),
            })),
        }))
        .addCase(setIsAutocompleteModeEnabled, (state, action) => ({
            ...state,
            items: state.items.map(item => ({
                ...item,
                ...(item.orderItemId === action.payload.orderItemId
                    ? {isAutocompleteModeEnabled: action.payload.isAutocompleteModeEnabled}
                    : {}),
            })),
        }))
        .addCase(setErrorsSuccessPage, (state, action) => ({
            ...state,
            itemsValidated: action.payload,
        }))
        .addCase(
            fetchOrderedItems.fulfilled,
            (state: SuccessPageType, action): SuccessPageType => ({
                ...state,
                items: (Array.isArray(action.payload.data) ? action.payload.data : [])
                    .filter(
                        orderedItem =>
                            orderedItem.product.isContactLenses &&
                            orderedItem.prescription.send_by !==
                                PRESCRIPTION_METHOD.UPLOAD_METHOD &&
                            orderedItem.product.type !== PRODUCT_TYPES.GIFT,
                    )
                    .map(
                        ({id, name, prescription, product: {img}}): FieldType => ({
                            image: img,
                            name,
                            orderItemId: String(id),
                            sendBy: prescription.send_by,
                            ...(prescription.send_by === PRESCRIPTION_METHOD.FILL_IT_ONLINE_METHOD
                                ? {
                                      doctorDetails: DOCTOR_DETAILS_DEFAULT,
                                      isAutocompleteModeEnabled: true,
                                  }
                                : {
                                      errorType: 0,
                                      fileName: '',
                                      fileSrc: '',
                                      fileType: 'image/jpeg',
                                      type: '',
                                  }),
                        }),
                    ),
                orderedItems: Array.isArray(action.payload.data) ? action.payload.data : [],
                status: 'fulfilled',
            }),
        )
        .addCase(fetchOrderedItems.pending, state => ({
            ...state,
            status: 'pending',
        }))
        .addCase(fetchOrderedItems.rejected, state => ({
            ...state,
            status: 'rejected',
        }))
        .addCase(
            changeSuccessScreen,
            (state: SuccessPageType, action): SuccessPageType => ({
                ...state,
                successScreen: action.payload,
            }),
        )
        .addCase(setVisibilyFailureMessage, (state, action) => ({
            ...state,
            visiblyDetails: {
                ...state.visiblyDetails,
                errors: {...state.visiblyDetails.errors, message: action.payload},
            },
        }))
        .addCase(setVisiblyFields, (state, action) => ({
            ...state,
            visiblyDetails: {...state.visiblyDetails, ...action.payload},
        }))
        .addCase(fetchExamID.fulfilled, (state, {payload}) => ({
            ...state,
            visiblyDetails: {
                ...state.visiblyDetails,
                examID: payload.data.id,
                examToken: payload.data.token,
            },
        }))
        .addCase(clearExamBind, state => ({
            ...state,
            visiblyDetails: {
                ...state.visiblyDetails,
                examToken: '',
            },
        }));
});
